import { createFileRoute } from '@tanstack/react-router';

import { MethodologyAssociationsTab } from '../../../components';

const Page = () => {
  const params = Route.useParams();

  return (
    <MethodologyAssociationsTab
      managedAccountMethodologyId={params.managedAccountMethodologyId}
    />
  );
};

export const Route = createFileRoute(
  '/methodologies/$managedAccountMethodologyId/associations'
)({
  component: Page
});
